export default __webpack_public_path__ + "static/media/hackathon-level-3.313b1934.svg";